import * as React from 'react';
import { useCallback } from 'react';
import { css } from '@emotion/core';
import LocalDiv from '../localization/LocalDiv';
import Msg from '../localization/Msg';
import { Str } from '../localization/translationKeys';
import Spacer from '../layout/Spacer';
import DatePicker from 'react-datepicker';
import { BENCHMARKS } from '../language/time';
import { BTN_GENERAL, BTN_HOVER } from './styles/button';
import { COLORS } from '../globalStyle/colors';


const styles = {
  wrapper: [
    css`
        /* Btn hover adds a border which moves contents onHover... this fixes that. */
        border: 1px solid transparent;
      `,
    BTN_GENERAL,
    BTN_HOVER,
    css`
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: ${COLORS.BLUE};
        color: ${COLORS.WHITE};
        padding: 0 12px;
        flex-grow: 1;
      `,
  ],
  picker:  css`
      color: ${COLORS.WHITE};
      background-color: transparent;
      border: none;
      outline: none;
      text-align: start;
    `,
};


type Props = {
  msg: string | Str;
  selectedDate: Date,
  onChangeDate: (newDate: Date) => void,
  disabled: boolean,
  className?: string;
  startOpen: boolean;
};


/**
 * MobileAddToCalendarBtn: a component that renders a date picker in a button-like format, forwarding clicks through to
 * the underlying component... It's ugly, and encapsulated here.
 */
const MobileDatePicker: React.FC<Props> = props => {
  const onClick = useCallback(event => event.target?.getElementsByTagName?.('input')?.[0]?.click?.(), []);

  return (
    <LocalDiv
      tabIndex={0}
      onClick={onClick}
      css={styles.wrapper}
      className={props.className}
    >
      <Msg str={props.msg} defaultMsg={props.msg} />
      <Spacer sizePx={3} />
      <DatePicker
        selected={props.selectedDate}
        onChange={props.onChangeDate}
        dateFormat='MMMM d, yyyy'
        disabled={props.disabled}
        minDate={BENCHMARKS.Y2K}
        css={styles.picker}
        startOpen={props.startOpen}
      />
    </LocalDiv>
  );
};

export default MobileDatePicker;
